import type { ReactElement } from 'react';
import { HomeRounded } from '@mui/icons-material';

const HomeIcon = (): ReactElement => (
    <HomeRounded sx={{ fontSize: 14, verticalAlign: '-2px' }} />
);

export default HomeIcon;
